module.exports = __webpack_public_path__ + "img/1106a_2.1e6ef5e0.jpg";